const LISTE_RELANCE_OPTION = {
  title: 'Liste relances d\'option',
  breadcrumb: {
    liste: 'Liste relances d\'option',
    racine: 'Accueil',
  },
  actions: {
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  card: {
    week: 'Semaine',
    payeur: 'Payeur(s)',
    annonceur: 'Annonceur(s)',
    face: 'Faces',
    commercial: 'Commercial',
    relancePar: 'Relancé par :',
    anneeSemaine: 'S{week} - {year}',
    noDefine: 'Non défini',
  },
  messages: {
    errors: {
      noResult: 'Aucune relance d\'option en attente',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    commercialRelance: 'Commercial relancé',
    commercialEnAttente: 'Commercial relanceur',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};

export default LISTE_RELANCE_OPTION;
